import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import RegulatoryUpdateWildcardRedirect from "@/components/LegacyRedirects";

export const Route = createFileRoute("/regulatory-updates/*")({
  head: () => buildRouteHead("/regulatory-updates/*", { noIndex: true }),
  component: RegulatoryUpdateWildcardRedirect,
});

